import { render, staticRenderFns } from "./taskListDialog.vue?vue&type=template&id=66bf802b&scoped=true&"
import script from "./taskListDialog.vue?vue&type=script&lang=js&"
export * from "./taskListDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskListDialog.vue?vue&type=style&index=0&id=66bf802b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf802b",
  null
  
)

export default component.exports